import { render } from "./XTabItem.vue?vue&type=template&id=68e824d2&scoped=true"
import script from "./XTabItem.vue?vue&type=script&lang=js"
export * from "./XTabItem.vue?vue&type=script&lang=js"

import "./XTabItem.vue?vue&type=style&index=0&id=68e824d2&lang=less&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.33_webpack@5.93.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68e824d2"]])

export default __exports__